import React from "react";
import { Fragment, useState, useEffect } from "react";
import axiosInstance from "./../../helpers/axiosInstance";
import ComponenteIps from "./ComponenteIps";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { cambioImagen } from "Slicersreducers";

import RandomImageComponent from "./RandomImageComponent";

import {
  Card,
  Container,
  Row,
  Col,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  CardHeader,
  Button,
  Modal,
  Badge,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Table,
  UncontrolledTooltip,
  Alert,
  InputGroup,
} from "reactstrap";
import IconTid from "../../assets/img/icons/Icono-Tipo-de-documento-Gris.png";
import IconNid from "../../assets/img/icons/Icono-Numero-documento-Gris.png";

const RegistroUsuarioExterno = (props) => {
  const [newUserName, setNewUserName] = useState("");
  //const [typesDocument, setTypesDocument] = useState("1");
  const [tidelec, settidelec] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const [dateExpedition, setDateExpedition] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [idImage, setIdImage] = useState("");
  const [securityQuestion, setSecurityQuestion] = useState("");
  const [contentFile, setContentFile] = useState("");
  const [nameFileCedula, setFileCedula] = useState("Selecciona Cédula");
  const [nameFileActa, setFileActa] = useState("Selecciona Acta");
  const [nameFileFormulario, setFileFormulario] = useState(
    "Selecciona Formulario"
  );

  const [listAlert, setListAlert] = useState([]);
  const [nombreCasillaCedula, setNombreCasillaCedula] =
    useState("Selecciona Cédula");
  const [nombreCasillaActa, setNombreCasillaActa] = useState("Selecciona Acta");
  const [nombreCasillaFormulario, setNombreCasillaFormulario] = useState(
    "Selecciona Formulario"
  );
  const [disableButton, setDisableButton] = useState(true);
  const [successModal, setSuccessModal] = useState(false);
  const [statusCedula, setStatusCedula] = useState(false);
  const [statusActa, setStatusActa] = useState(false);
  const [statusFormulario, setStatusFormulario] = useState(false);
  const [statusNombre, setStatusNombre] = useState(false);
  const [statusFechaExp, setStatusFechaExp] = useState(false);
  const [statusFraseSeg, setStatusFraseSeg] = useState(false);
  const [statusImage, setStatusImage] = useState(false);
  const [newCedula, setNewCedula] = useState("");
  const [newActa, setNewActa] = useState("");
  const [newFormulario, setNewFormulario] = useState("");
  const [listIps, setListIps] = useState([]);
  const [successModalWithErrors, setSuccessModalWithErrors] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const infoIps = (Ips) => {
    setListIps(Ips);
    if (listIps != []) {
      setDisableButton(false);
    }
  };

  const sendImage = (Id) => {
    setIdImage(Id);
    if (idImage != null) {
      setStatusImage(true);
    } else {
      setStatusImage(false);
    }
  };

  const handleChangeName = (event) => {
    event.preventDefault();
    console.log("esta editando");
    setNewUserName(event.target.value);
    auxBuildUser.newUserName = newUserName;
    console.log(newUserName);
    if (newUserName.length > 1) {
      setStatusNombre(true);
    } else {
      setStatusNombre(false);
    }
  };
  var createReactClass = require("create-react-class");

  const handleChangeDate = (event) => {
    event.preventDefault();
    setDateExpedition(event.target.value);
    console.log(dateExpedition);
    if (event.target.value) {
      setStatusFechaExp(true);
    } else {
      setStatusFechaExp(false);
    }
  };

  const handleChangeEmail = (event) => {
    event.preventDefault();
    setEmail(event.target.value);
    auxBuildUser.email = event.target.value;
    errorMail();
    console.log(email);
  };

  const handleChangePhone = (event) => {
    event.preventDefault();
    setPhone(event.target.value);
    auxBuildUser.phone = event.target.value;
    console.log(phone);
  };
  var auxBuildUser = {
    tid: "",
    nit: "",
    tus: "",
    newUserName: "",
    idNumber: "",
    dateExpedition: "",
    email: "",
    phone: "",
    id: "",
    securityQuestion: "",
  };

  const handleChangeSecurity = (event) => {
    event.preventDefault();
    setSecurityQuestion(event.target.value);
    auxBuildUser.securityQuestion = event.target.value;
    console.log(securityQuestion);
    if (securityQuestion != "") {
      setStatusFraseSeg(true);
    } else {
      setStatusFraseSeg(false);
    }
  };

  function getDateString(d) {
    var dd = d.getDate();
    var mm = d.getMonth() + 1;
    var yyyy = d.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    return yyyy + "" + mm + "" + dd;
  }

  const addDocumentFormulario = async () => {
    let today = new Date();
    let solicitud = props.dataUser.numberIdCompany;
    solicitud = solicitud.padEnd(16);
    const document = {
      nomPlantilla: "FOSPOTRA",
      numSolicitud: solicitud + "3",
      fechaEmision: getDateString(today),
      extension: "PDF",
      archivo: newFormulario,
      nidCliente: props.dataUser.numberIdUser,
    };

    const request = await axiosInstance()
      .post("/WSGYG39B/api/documentos/CargarDocumentos", document)
      .catch((err) => {
        try {
          if (err.response.data.errors) {
            setListAlert(
              err.response.data.errors.map((o) => ({
                ...o,
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle",
              }))
            );
          } else {
            setListAlert([
              {
                description: "Error.",
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle",
              },
            ]);
          }
        } catch (error) {
          setListAlert([
            {
              description: "Por favor validar la información ingresada.",
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle",
            },
          ]);
        }
        return "err";
      });
    if (request != "err") {
      setIsLoading(false);
      setSuccessModal(true);
    } else {
      setIsLoading(false);
      setSuccessModalWithErrors(true);
    }
  };

  const addDocumentActa = async () => {
    let today = new Date();
    let solicitud = props.dataUser.numberIdCompany;
    solicitud = solicitud.padEnd(16);
    const document = {
      nomPlantilla: "ACTPSOCE",
      numSolicitud: solicitud + "3",
      fechaEmision: getDateString(today),
      extension: "PDF",
      archivo: newActa,
      nidCliente: props.dataUser.numberIdUser,
    };

    const request = await axiosInstance()
      .post("/WSGYG39B/api/documentos/CargarDocumentos", document)
      .catch((err) => {
        try {
          if (err.response.data.errors) {
            setListAlert(
              err.response.data.errors.map((o) => ({
                ...o,
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle",
              }))
            );
          } else {
            setListAlert([
              {
                description: "Error.",
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle",
              },
            ]);
          }
        } catch (error) {
          setListAlert([
            {
              description: "Por favor validar la información ingresada.",
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle",
            },
          ]);
        }
        return "err";
      });
    if (request != "err") {
      addDocumentFormulario();
    } else {
      setIsLoading(false);
      setSuccessModalWithErrors(true);
    }
  };

  const addDocumentCedula = async () => {
    let today = new Date();
    let solicitud = props.dataUser.numberIdCompany;
    solicitud = solicitud.padEnd(16);
    const document = {
      nomPlantilla: "CEDULACL",
      numSolicitud: solicitud + "3",
      fechaEmision: getDateString(today),
      extension: "PDF",
      archivo: newCedula,
      nidCliente: props.dataUser.numberIdUser,
    };

    const request = await axiosInstance()
      .post("/WSGYG39B/api/documentos/CargarDocumentos", document)
      .catch((err) => {
        try {
          if (err.response.data.errors) {
            setListAlert(
              err.response.data.errors.map((o) => ({
                ...o,
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle",
              }))
            );
          } else {
            setListAlert([
              {
                description: "Error.",
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle",
              },
            ]);
          }
        } catch (error) {
          setListAlert([
            {
              description: "Por favor validar la información ingresada.",
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle",
            },
          ]);
        }
        return "err";
      });
    if (request != "err") {
      addDocumentActa();
    } else {
      setIsLoading(false);
      setSuccessModalWithErrors(true);
    }
  };

  const AddRelatedUser = async () => {
    const relatedUser = {
      NameUser: newUserName,
      TypeUser: props.dataUser.typeUser,
      TypeUser1: props.dataUser.typeUser1,
      ProfileCode: props.dataUser.profileCode,
      ConditionDescription: props.dataUser.conditionDescription,
      Status: props.dataUser.status,
      TypeIdUser: props.dataUser.typeIdUser,
      NumberIdUser: props.dataUser.numberIdUser,
      TypeIdCompany: "3",
      NumberIdCompany: props.dataUser.numberIdCompany,
      Email: email.toLowerCase(),
      Phone: phone,
      DateExpedition: dateExpedition.replaceAll("-", ""),
      SecurityText: securityQuestion,
      IdImage: idImage,
      Ips: listIps,
    };

    if (
      statusCedula &&
      statusActa &&
      statusFormulario &&
      statusNombre &&
      statusFechaExp &&
      statusFraseSeg &&
      statusImage
    ) {
      setIsLoading(true);
      const request = await axiosInstance()
        .post("/WSGYG39B/api/Form/CreateForm", relatedUser)
        .catch((err) => {
          try {
            if (err.response.data.errors) {
              setListAlert(
                err.response.data.errors.map((o) => ({
                  ...o,
                  type: "alert alert-alert show alert-dismissible fade alert-danger",
                  icon: "fas fa-exclamation-circle",
                }))
              );
            } else {
              setListAlert([
                {
                  description: "Error.",
                  type: "alert alert-alert show alert-dismissible fade alert-danger",
                  icon: "fas fa-exclamation-circle",
                },
              ]);
            }
          } catch (error) {
            setListAlert([
              {
                description: "Por favor validar la información ingresada.",
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle",
              },
            ]);
          }
          return "err";
        });
      if (request != "err") {
        addDocumentCedula();
        //setSuccessModal(true);

        console.log(request.data);
      } else {
        setIsLoading(false);
      }
    } else if (props.dataUser.typeUser == "S") {
      if (statusNombre && statusFraseSeg && statusFechaExp && statusImage) {
        const request = await axiosInstance()
          .post("/WSGYG39B/api/Form/CreateForm", relatedUser)
          .catch((err) => {
            try {
              if (err.response.data.errors) {
                setListAlert(
                  err.response.data.errors.map((o) => ({
                    ...o,
                    type: "alert alert-alert show alert-dismissible fade alert-danger",
                    icon: "fas fa-exclamation-circle",
                  }))
                );
              } else {
                setListAlert([
                  {
                    description: "Error.",
                    type: "alert alert-alert show alert-dismissible fade alert-danger",
                    icon: "fas fa-exclamation-circle",
                  },
                ]);
              }
            } catch (error) {
              setListAlert([
                {
                  description: "Por favor validar la información ingresada.",
                  type: "alert alert-alert show alert-dismissible fade alert-danger",
                  icon: "fas fa-exclamation-circle",
                },
              ]);
            }
            return "err";
          });
        if (request != "err") {
          setSuccessModal(true);
          console.log(request.data);
        }
      } else {
        setListAlert([
          {
            description: "Por favor diligencie toda la información solicitada.",
            type: "alert alert-alert show alert-dismissible fade alert-danger",
            icon: "fas fa-exclamation-circle",
          },
        ]);
      }
    } else {
      setListAlert([
        {
          description: "Por favor diligencie toda la información solicitada.",
          type: "alert alert-alert show alert-dismissible fade alert-danger",
          icon: "fas fa-exclamation-circle",
        },
      ]);
    }
  };

  const ejecutasalirSuccessModal = () => {
    setSuccessModal(false);
    dispatch(cambioImagen(true));
  };
  const ejecutasalirSuccessModalWithErrors = () => {
    setSuccessModalWithErrors(false);
    dispatch(cambioImagen(true));
  };

  async function ShowFileCedula(event) {
    var file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      setFileCedula(reader.result);
      setNewCedula(reader.result);
    };
    reader.readAsDataURL(file);
    setNombreCasillaCedula(file.name);
    setStatusCedula(true);
  }

  async function ShowFileActa(event) {
    var file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      setFileActa(reader.result);
      setNewActa(reader.result);
    };
    reader.readAsDataURL(file);
    setNombreCasillaActa(file.name);
    setStatusActa(true);
  }

  async function ShowFileFormulario(event) {
    var file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      setFileFormulario(reader.result);
      setNewFormulario(reader.result);
    };
    reader.readAsDataURL(file);
    setNombreCasillaFormulario(file.name);
    setStatusFormulario(true);
  }

  const deleteAlert = (alert) => {
    console.log("elimina alerta");
    console.log(listAlert);
    setListAlert(listAlert.filter((auxAlert) => auxAlert != alert));
  };

  useEffect(async () => {
    const timer = setTimeout(deleteElementFromArr, 5000);
    return () => clearTimeout(timer);
  });

  const deleteElementFromArr = () => {
    if (listAlert.length > 0) {
      let temp = listAlert.slice();
      temp.splice(0, 1);
      setListAlert(temp);
    }
  };

  const eliminarContentCedula = () => {
    const fileInput = document.getElementById("inputFileCedula"); // Obtén la referencia al input de tipo file
    fileInput.value = ""; // Borra el valor del input
    setStatusCedula(false);
  };

  const eliminarContentActa = () => {
    const fileInput = document.getElementById("inputFileActa"); // Obtén la referencia al input de tipo file
    fileInput.value = ""; // Borra el valor del input
    setStatusActa(false);
  };

  const eliminarContentFormulario = () => {
    const fileInput = document.getElementById("inputFileFormulario"); // Obtén la referencia al input de tipo file
    fileInput.value = ""; // Borra el valor del input
    setStatusFormulario(false);
  };

  //Valida que el patrón del correo sea el correcto
  const errorMail = () => {
    const emailInput = document.getElementById("email");
    const errorMessage = document.getElementById("error-message");

    emailInput.addEventListener("input", function () {
      const email = emailInput.value;
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

      if (emailPattern.test(email)) {
        errorMessage.textContent = ""; // Email válido, no muestra mensaje de error
      } else {
        errorMessage.textContent = "Correo electrónico no válido";
      }
    });
  };

  var Alerts = createReactClass({
    render: function () {
      var data = this.props.data;
      var newsTemplate;
      if (data.length > 0) {
        newsTemplate = data.map(function (item, index) {
          return (
            <div class={item.type} role="alert">
              <button
                type="button"
                class="close"
                aria-label="Close"
                onClick={() => deleteAlert(item)}
              >
                <span aria-hidden="true">×</span>
              </button>
              <span className="alert-inner--icon mr-3">
                <i className={item.icon} />
              </span>{" "}
              <span class="alert-inner--text">{item.description}</span>
            </div>
          );
        });
      }
      return <div className="toast-bottom-right">{newsTemplate}</div>;
    },
  });

  return (
    <>
      <Modal
        className="modal-dialog-centered"
        contentClassName=""
        isOpen={successModal}
        //toggle={() => setSuccessModal(!successModal)}
      >
        <div className="p-4">
          <Link to="auth/cambioCotraseña">
            <div
              onClick={ejecutasalirSuccessModal}
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <h1 style={{ margin: "-15px -10px 0px 0px", fontSize: "20px" }}>
                <span aria-hidden={true} style={{ fontSize: 1.5 + "rem" }}>
                  <img
                    className=""
                    src={
                      require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo-Verde.png")
                        .default
                    }
                  />
                </span>
              </h1>
            </div>
          </Link>
          <div class="my-modal-header">
            <img
              style={{ width: "100px", height: "100px" }}
              alt="delete-icon"
              class="my-header-image"
              src={
                require("../../assets/img/illustrations/Success-transfer.png")
                  .default
              }
            />
            <div class="header-title">
              <h5 class="avv-title-bold">El proceso fue exitoso</h5>
              <p class="header-subtitle">El usuario fue creado correctamente</p>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        className="modal-dialog-centered"
        contentClassName=""
        isOpen={successModalWithErrors}
        //toggle={() => setSuccessModal(!successModal)}
      >
        <div className="p-4">
          <Link to="auth/cambioCotraseña">
            <div
              onClick={ejecutasalirSuccessModalWithErrors}
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <h1 style={{ margin: "-15px -10px 0px 0px", fontSize: "20px" }}>
                <span aria-hidden={true} style={{ fontSize: 1.5 + "rem" }}>
                  <img
                    className=""
                    src={
                      require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo-Verde.png")
                        .default
                    }
                  />
                </span>
              </h1>
            </div>
          </Link>
          <div class="my-modal-header">
            <img
              style={{ width: "100px", height: "100px" }}
              alt="delete-icon"
              class="my-header-image"
              src={
                require("../../assets/img/illustrations/Success-transfer.png")
                  .default
              }
            />
            <div class="header-title">
              <h5 class="avv-title-bold">El proceso fue exitoso</h5>
              <p class="header-subtitle">
                El usuario fue creado correctamente, pero no cargaron bien los
                archivos
              </p>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        className="modal-dialog-centered"
        contentClassName="bg-transparent shadow-none"
        isOpen={isLoading}
      >
        <div
          tabindex="-1"
          style={{
            position: "relative;",
            "z-index": "1050",
            display: "block",
            width: "100%",
            height: "80vh",
          }}
        >
          <div
            style={{
              "text-align": "center",
              top: "50%",
              position: "relative",
            }}
          >
            <img
              style={{ height: "100px" }}
              src={require("../../assets/img/icons/LoaderIDEA.gif").default}
            ></img>
          </div>
          <div class="modal-backdrop fade show"></div>
        </div>
      </Modal>
      <Fragment>
        <div className="header pb-4 pt-4">
          <Container className="ml-1" fluid style={{ width: "100%" }}>
            <div style={{ marginLeft: "800px" }}>
              <img
                src={
                  require("../../assets/img/icons/Flecha Abajo-Verde-blanca.png")
                    .default
                }
              />
              <a
                role="button"
                className="h6 mb-0 ml-0 text-green"
                href="auth/UsuariosExternos"
                onClick={() => {
                  dispatch(cambioImagen(true));
                }}
              >
                {"Regresar a inicio"}
              </a>
            </div>
            <div>
              <p className="text-green">Nit:{props.dataUser.numberIdCompany}</p>
            </div>

            <div>
              <strong>Registro</strong>
              <p>
                Para completar el registro por favor diligencie estos campos con
                su información personal
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "3px",
                  borderTop: "#DFE4E1 1px solid",
                  borderLeft: "#DFE4E1 1px solid",
                  borderRight: "#DFE4E1 1px solid",
                  borderBottom: "#767676 1px solid",
                  padding: "4px 8px 4px 4px",
                  borderRadius: "5px 5px 0px 0px",
                  margin: "15px",
                  width: "865px",
                }}
              >
                <input
                  required
                  maxLength={50}
                  onChange={handleChangeName}
                  type="text"
                  value={newUserName}
                  style={{
                    fontSize: "14px",
                    border: "none",
                    width: "855px",
                    height: "25px",
                    padding: "0px 0px 0px 5px",
                    margin: "0px 0px 0px 0px",
                  }}
                  placeholder="Nombre completo"
                />
              </div>
              <div style={{ display: "flex" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "3px",
                    borderTop: "#DFE4E1 1px solid",
                    borderLeft: "#DFE4E1 1px solid",
                    borderRight: "#DFE4E1 1px solid",
                    borderBottom: "#767676 1px solid",
                    padding: "4px 8px 4px 4px",
                    borderRadius: "5px 5px 0px 0px",
                    margin: "15px",
                    width: "285px",
                  }}
                >
                  <input
                    readonly
                    disabled
                    value={props.dataUser.typeIdUser}
                    style={{
                      fontSize: "14px",
                      border: "none",
                      width: "855px",
                      height: "25px",
                      padding: "0px 0px 0px 5px",
                      margin: "0px 0px 0px 0px",
                    }}
                  />
                  <img style={{ height: "12px" }} src={IconTid}></img>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "3px",
                    borderTop: "#DFE4E1 1px solid",
                    borderLeft: "#DFE4E1 1px solid",
                    borderRight: "#DFE4E1 1px solid",
                    borderBottom: "#767676 1px solid",
                    padding: "4px 8px 4px 4px",
                    borderRadius: "5px 5px 0px 0px",
                    margin: "15px",
                    width: "270px",
                  }}
                >
                  <input
                    readonly
                    disabled
                    value={props.dataUser.numberIdUser}
                    style={{
                      fontSize: "14px",
                      border: "none",
                      width: "250px",
                      height: "25px",
                      padding: "0px 0px 0px 5px",
                      margin: "0px 0px 0px 0px",
                    }}
                    placeholder="Número de documento"
                  />
                  <img style={{ height: "12px" }} src={IconNid} />
                </div>
                <InputGroup>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "3px",
                      borderTop: "#DFE4E1 1px solid",
                      borderLeft: "#DFE4E1 1px solid",
                      borderRight: "#DFE4E1 1px solid",
                      borderBottom: "#767676 1px solid",
                      padding: "4px 8px 4px 4px",
                      borderRadius: "5px 5px 0px 0px",
                      margin: "15px",
                      width: "250px",
                    }}
                  >
                    <input
                      type="date"
                      max="2023-12-31"
                      onChange={handleChangeDate}
                      value={dateExpedition}
                      style={{
                        fontSize: "14px",
                        border: "none",
                        width: "300px",
                        height: "25px",
                        padding: "0px 0px 0px 5px",
                        margin: "0px 0px 0px 0px",
                      }}
                      placeholder="Fecha expedición"
                    />
                    <i style={{ fontSize: "10px" }}>Fecha de expedición</i>
                  </div>
                </InputGroup>
              </div>
              <div style={{ display: "flex" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "3px",
                    borderTop: "#DFE4E1 1px solid",
                    borderLeft: "#DFE4E1 1px solid",
                    borderRight: "#DFE4E1 1px solid",
                    borderBottom: "#767676 1px solid",
                    padding: "4px 8px 4px 4px",
                    borderRadius: "5px 5px 0px 0px",
                    margin: "15px",
                    width: "380px",
                  }}
                >
                  <input
                    type="text"
                    id="email"
                    onChange={handleChangeEmail}
                    value={email}
                    style={{
                      fontSize: "14px",
                      border: "none",
                      width: "360px",
                      height: "25px",
                      padding: "0px 0px 0px 5px",
                      margin: "0px 0px 0px 0px",
                    }}
                    placeholder="Correo electrónico"
                  />
                  <span
                    style={{ fontSize: "10px" }}
                    id="error-message"
                    className="text-primary"
                  ></span>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "1px",
                    borderTop: "#DFE4E1 1px solid",
                    borderLeft: "#DFE4E1 1px solid",
                    borderRight: "#DFE4E1 1px solid",
                    borderBottom: "#767676 1px solid",
                    padding: "4px 8px 4px 4px",
                    borderRadius: "5px 5px 0px 0px",
                    margin: "15px",
                    width: "320px",
                  }}
                >
                  <input
                    maxLength={11}
                    onChange={handleChangePhone}
                    value={phone}
                    style={{
                      fontSize: "14px",
                      border: "none",
                      width: "310px",
                      height: "25px",
                      padding: "0px 0px 0px 5px",
                      margin: "0px 0px 0px 0px",
                    }}
                    placeholder="Teléfono"
                  />
                </div>
              </div>
            </div>
            <strong>Seguridad</strong>
            <p>Por favor seleccione una imagen de seguridad</p>
            <div
              className="ml-3 mr-9"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "3px",
              }}
            >
              <RandomImageComponent
                sendImage={sendImage}
              ></RandomImageComponent>
            </div>

            <p>Por favor escriba una frase de seguridad</p>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "3px",
                borderTop: "#DFE4E1 1px solid",
                borderLeft: "#DFE4E1 1px solid",
                borderRight: "#DFE4E1 1px solid",
                borderBottom: "#767676 1px solid",
                padding: "4px 8px 4px 4px",
                borderRadius: "5px 5px 0px 0px",
                margin: "15px",
                width: "865px",
              }}
            >
              <input
                required
                maxLength={50}
                pattern="[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]+"
                onChange={handleChangeSecurity}
                value={securityQuestion}
                style={{
                  fontSize: "14px",
                  border: "none",
                  width: "855px",
                  height: "25px",
                  padding: "0px 0px 0px 5px",
                  margin: "0px 0px 0px 0px",
                }}
                placeholder="Frase de seguridad"
              />
            </div>
            <p>Registra al menos una IP para tu próximo Ingreso</p>
            <ComponenteIps infoIps={infoIps}></ComponenteIps>
            {props.dataUser.typeUser == "N" && (
              <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                <div style={{ width: "400px" }}>
                  <strong>Adjuntar archivos</strong>{" "}
                  <p>Los documentos deben estar en PDF</p>
                  <p>
                    Para completar el registro por favor adjunte los siguientes
                    documentos:
                  </p>
                  <ul>
                    <li>Copia cédula de ciudadanía ampliada al 150%</li>
                    <li>Acta de posesión o certificación laboral</li>
                    <li>
                      Formulario de solicitud de portal transaccional
                      diligenciado
                    </li>
                  </ul>
                </div>
                <div style={{ display: "table-column" }} className="mr-1">
                  <form
                    className="mt-4"
                    style={{ width: "380px", height: "40px" }}
                  >
                    <div
                      className="file-upload-wrapper2"
                      data-text={nombreCasillaCedula}
                    >
                      <input
                        id="inputFileCedula"
                        name="file-upload-field"
                        accept=".pdf"
                        type="file"
                        class="file-upload-field"
                        value=""
                        onChange={ShowFileCedula}
                      />
                    </div>
                  </form>
                  <form
                    className="mt-4"
                    style={{ width: "380px", height: "40px" }}
                  >
                    <div
                      className="file-upload-wrapper2"
                      data-text={nombreCasillaActa}
                    >
                      <input
                        id="inputFileActa"
                        name="file-upload-field"
                        accept=".pdf"
                        type="file"
                        class="file-upload-field"
                        value=""
                        onChange={ShowFileActa}
                      />
                    </div>
                  </form>
                  <form
                    className="mt-4"
                    style={{ width: "380px", height: "40px" }}
                  >
                    <div
                      className="file-upload-wrapper2"
                      data-text={nombreCasillaFormulario}
                    >
                      <input
                        id="inputFileFormulario"
                        name="file-upload-field"
                        accept=".pdf"
                        type="file"
                        class="file-upload-field"
                        value=""
                        onChange={ShowFileFormulario}
                      />
                    </div>
                  </form>
                </div>
                <div style={{ display: "table-column" }}>
                  <div style={{ width: "200px" }} className="mt-4">
                    <Button
                      onClick={() => {
                        setNombreCasillaCedula("Selecciona Cédula");
                        eliminarContentCedula();
                      }}
                      style={{ border: "none", width: "100px", height: "25%" }}
                      className="my-1 mt-4 mr-9 btn bg-green text-white btn-block"
                    >
                      Eliminar
                    </Button>
                  </div>
                  <div style={{ width: "200px" }} className="mt-4">
                    <Button
                      onClick={() => {
                        setNombreCasillaActa("Selecciona Acta");
                        eliminarContentActa();
                      }}
                      style={{ border: "none", width: "100px", height: "25%" }}
                      className="my-1 mt-4 mr-9 btn bg-green text-white btn-block"
                    >
                      Eliminar
                    </Button>
                  </div>
                  <div style={{ width: "200px" }} className="mt-4">
                    <Button
                      onClick={() => {
                        setNombreCasillaFormulario("Selecciona Formulario");
                        eliminarContentFormulario();
                      }}
                      style={{ border: "none", width: "100px", height: "25%" }}
                      className="my-1 mt-4 mr-9 btn bg-green text-white btn-block"
                    >
                      Eliminar
                    </Button>
                  </div>
                </div>
              </div>
            )}
            <div>
              <Button
                style={{ width: "25%", border: "none" }}
                //isLoading={isLoading}
                disabled={disableButton}
                onClick={() => {
                  AddRelatedUser();
                }}
                className="my-1 mt-3 btn bg-green text-white btn-block ml-auto mr-auto"
              >
                Continuar
              </Button>
            </div>
            <Alerts data={listAlert}></Alerts>
          </Container>
        </div>
      </Fragment>
    </>
  );
};

export default RegistroUsuarioExterno;
